import React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { Link } from "react-router-dom";




const CTASection = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        boxShadow: 2,

        paddingTop: { xs: '3rem', sm: '5rem' },
        paddingBottom: { xs: '3rem', sm: '5rem' },
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
          backgroundColor: '#f8f9fa',
          backgroundPosition: 'center',
          backgroundSize: 'cover',

        }}
      />

      <Container >
        <Grid container spacing={4} justifyContent="center" alignItems="center">
          {/* Left Section: Text */}
          <Grid item xs={12} lg={8} sx={{ textAlign: { xs: 'center', lg: 'left' } }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2, color: "#000" }}>
              All-in-one platform for personal financial consultant
            </Typography>
            <Typography sx={{ paddingRight: { xs: 0, sm: '3rem' }, color: "#000" }}>
              With client management, investment tracking, and professional guidance all in one location, our app serves as a comprehensive platform for personal financial consultants.
            </Typography>
          </Grid>

          {/* Right Section: Button */}
          <Grid item xs={12} lg={3} sx={{ textAlign: { xs: 'center', lg: 'right' } }}>
            <Link to="/contact">
              <Button
                variant="contained"
                sx={{
                  padding: '1rem 2rem', fontSize: '1rem', textTransform: 'none', backgroundColor: '#1a7d3b',
                  '&:hover': {
                    backgroundColor: '#156e29',
                  },
                }}
              >
                Get In Touch
              </Button>
            </Link>

          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CTASection;

